import { SearchContextsEnum } from '../enums/search-contexts.enum';

export class SearchContextModel {
    private static nameMap: Map<SearchContextsEnum, string> = new Map(
        [
            [SearchContextsEnum.text, 'SearchContext.text'],
            [SearchContextsEnum.header, 'SearchContext.headline'],
            [SearchContextsEnum.lead, 'SearchContext.lead'],
            [SearchContextsEnum.body, 'SearchContext.body'],
            [SearchContextsEnum.images, 'SearchContext.images']
        ]
    );

    name: string;
    value: SearchContextsEnum;

    constructor(value: SearchContextsEnum, name?: string) {
        this.value = value;
        if (name) {
            this.name = name;
        } else {
            this.name = SearchContextModel.nameMap.get(value);
        }
    }
}
